export default __webpack_public_path__ + "static/media/Ballroll_00231.cb5111f3.png";